import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import { useSelector, useDispatch } from 'react-redux';
import { selectCartCount, setSelectedCategory, setSelectedBrand, selectLanguage, setLanguage, setSearchQuery, selectSearchQuery } from '../redux/cartSlice';
import { translations } from '../utils/translations';
import useWishlist from '../hooks/useWishlist';

const menuTranslations = {
  en: {
    phoneCases: "Phone Cases",
    screenProtectors: "Screen Protectors",
    chargingCables: "Charging Cables",
    powerBanks: "Power Banks",
    smartWatches: "Smart Watches",
    fitnessBands: "Fitness Bands",
    wirelessEarbuds: "Wireless Earbuds",
    smartSpeakers: "Smart Speakers",
    screenRepair: "Screen Repair",
    batteryReplacement: "Battery Replacement",
    softwareIssues: "Software Issues",
    warrantySupport: "Warranty Support",
    oemScreens: "OEM Screens",
    partsBatteries: "Batteries",
    cameraModules: "Camera Modules",
    chargingPorts: "Charging Ports",
    weeklySpecialDeals: "Weekly Special Deals",
    clearanceSale: "Clearance Sale",
    bundleDiscounts: "Bundle Discounts",
    tradeInOffers: "Trade-In Offers",
    gamingLaptops: "Gaming Laptops",
    appleMacbooks: "Apple MacBooks",
    allInOneDesktops: "All-in-One Desktops",
    computerComponents: "Computer Components",
    certifiedRefurbished: "Certified Refurbished",
    preOwnedIphones: "Pre-Owned iPhones",
    usedSamsungGalaxy: "Used Samsung Galaxy",
    budgetUsedPhones: "Budget Used Phones",
    smartTVs: "Smart TVs",
    actionCameras: "Action Cameras",
    soundbarsSpeakers: "Soundbars & Speakers",
    playstationXbox: "PlayStation & Xbox"
  },
  nl: {
    phoneCases: "Telefoonhoesjes",
    screenProtectors: "Screenprotectors",
    chargingCables: "Oplaadkabels",
    powerBanks: "Powerbanks",
    smartWatches: "Smartwatches",
    fitnessBands: "Fitnessbandjes",
    wirelessEarbuds: "Draadloze Oordopjes",
    smartSpeakers: "Slimme Speakers",
    screenRepair: "Schermreparatie",
    batteryReplacement: "Batterij Vervangen",
    softwareIssues: "Softwareproblemen",
    warrantySupport: "Garantie Ondersteuning",
    oemScreens: "OEM Schermen",
    partsBatteries: "Batterijen",
    cameraModules: "Cameramodules",
    chargingPorts: "Oplaadpoorten",
    weeklySpecialDeals: "Wekelijkse Speciale Deals",
    clearanceSale: "Opruiming",
    bundleDiscounts: "Bundelkortingen",
    tradeInOffers: "Inruil aanbiedingen",
    gamingLaptops: "Gaming Laptops",
    appleMacbooks: "Apple MacBooks",
    allInOneDesktops: "All-in-One Desktops",
    computerComponents: "Computeronderdelen",
    certifiedRefurbished: "Gecertificeerd Gereviseerd",
    preOwnedIphones: "Tweedehands iPhones",
    usedSamsungGalaxy: "Gebruikte Samsung Galaxy",
    budgetUsedPhones: "Goedkope Gebruikte Telefoons",
    smartTVs: "Smart-tv's",
    actionCameras: "Actioncamera's",
    soundbarsSpeakers: "Soundbars & Luidsprekers",
    playstationXbox: "PlayStation & Xbox"
  },
  es: {
    phoneCases: "Fundas para Teléfono",
    screenProtectors: "Protectores de Pantalla",
    chargingCables: "Cables de Carga",
    powerBanks: "Baterías Externas",
    smartWatches: "Relojes Inteligentes",
    fitnessBands: "Pulseras de Actividad",
    wirelessEarbuds: "Auriculares Inalámbricos",
    smartSpeakers: "Altavoces Inteligentes",
    screenRepair: "Reparación de Pantalla",
    batteryReplacement: "Reemplazo de Batería",
    softwareIssues: "Problemas de Software",
    warrantySupport: "Soporte de Garantía",
    oemScreens: "Pantallas OEM",
    partsBatteries: "Baterías",
    cameraModules: "Módulos de Cámara",
    chargingPorts: "Puertos de Carga",
    weeklySpecialDeals: "Ofertas Especiales Semanales",
    clearanceSale: "Venta de Liquidación",
    bundleDiscounts: "Descuentos por Paquete",
    tradeInOffers: "Ofertas de Intercambio",
    gamingLaptops: "Laptops para Juegos",
    appleMacbooks: "Apple MacBooks",
    allInOneDesktops: "Computadoras Todo en Uno",
    computerComponents: "Componentes de Computadora",
    certifiedRefurbished: "Certificado Reacondicionado",
    preOwnedIphones: "iPhones Seminuevos",
    usedSamsungGalaxy: "Samsung Galaxy Usado",
    budgetUsedPhones: "Teléfonos Usados Económicos",
    smartTVs: "Televisores Inteligentes",
    actionCameras: "Cámaras de Acción",
    soundbarsSpeakers: "Barras de Sonido y Altavoces",
    playstationXbox: "PlayStation y Xbox"
  },
  fr: {
    phoneCases: "Coques de Téléphone",
    screenProtectors: "Protecteurs d'Écran",
    chargingCables: "Câbles de Charge",
    powerBanks: "Batteries Externes",
    smartWatches: "Montres Connectées",
    fitnessBands: "Bracelets Connectés",
    wirelessEarbuds: "Écouteurs Sans Fil",
    smartSpeakers: "Enceintes Intelligentes",
    screenRepair: "Réparation d'Écran",
    batteryReplacement: "Remplacement de Batterie",
    softwareIssues: "Problèmes de Logiciel",
    warrantySupport: "Support de Garantie",
    oemScreens: "Écrans OEM",
    partsBatteries: "Batteries",
    cameraModules: "Modules de Caméra",
    chargingPorts: "Ports de Charge",
    weeklySpecialDeals: "Offres Spéciales Hebdomadaires",
    clearanceSale: "Vente de Liquidation",
    bundleDiscounts: "Remises sur Lots",
    tradeInOffers: "Offres de Reprise",
    gamingLaptops: "PC Portables Gaming",
    appleMacbooks: "Apple MacBooks",
    allInOneDesktops: "Ordinateurs Tout-en-Un",
    computerComponents: "Composants Informatiques",
    certifiedRefurbished: "Certifié Reconditionné",
    preOwnedIphones: "iPhones d'Occasion",
    usedSamsungGalaxy: "Samsung Galaxy d'Occasion",
    budgetUsedPhones: "Téléphones d'Occasion Pas Chers",
    smartTVs: "Téléviseurs Intelligents",
    actionCameras: "Caméras d'Action",
    soundbarsSpeakers: "Barres de Son et Enceintes",
    playstationXbox: "PlayStation & Xbox"
  },
  de: {
    phoneCases: "Handyhüllen",
    screenProtectors: "Displayschutzfolien",
    chargingCables: "Ladekabel",
    powerBanks: "Powerbanks",
    smartWatches: "Smartwatches",
    fitnessBands: "Fitness-Tracker",
    wirelessEarbuds: "Kabellose Ohrhörer",
    smartSpeakers: "Intelligente Lautsprecher",
    screenRepair: "Bildschirmreparatur",
    batteryReplacement: "Akkutausch",
    softwareIssues: "Softwareprobleme",
    warrantySupport: "Garantie-Support",
    oemScreens: "OEM-Bildschirme",
    partsBatteries: "Akkus",
    cameraModules: "Kameramodule",
    chargingPorts: "Ladeanschlüsse",
    weeklySpecialDeals: "Wöchentliche Sonderangebote",
    clearanceSale: "Räumungsverkauf",
    bundleDiscounts: "Paket-Rabatte",
    tradeInOffers: "Inzahlungnahme-Angebote",
    gamingLaptops: "Gaming-Laptops",
    appleMacbooks: "Apple MacBooks",
    allInOneDesktops: "All-in-One-Desktops",
    computerComponents: "Computerkomponenten",
    certifiedRefurbished: "Zertifiziert Generalüberholt",
    preOwnedIphones: "Gebrauchte iPhones",
    usedSamsungGalaxy: "Gebrauchtes Samsung Galaxy",
    budgetUsedPhones: "Günstige Gebrauchte Handys",
    smartTVs: "Smart-TVs",
    actionCameras: "Action-Cams",
    soundbarsSpeakers: "Soundbars & Lautsprecher",
    playstationXbox: "PlayStation & Xbox"
  },
  it: {
    phoneCases: "Custodie per Telefono",
    screenProtectors: "Pellicole Protettive",
    chargingCables: "Cavi di Ricarica",
    powerBanks: "Power Bank",
    smartWatches: "Smartwatch",
    fitnessBands: "Smartband",
    wirelessEarbuds: "Auricolari Bluetooth",
    smartSpeakers: "Altoparlanti Intelligenti",
    screenRepair: "Riparazione Schermo",
    batteryReplacement: "Sostituzione Batteria",
    softwareIssues: "Problemi Software",
    warrantySupport: "Supporto in Garanzia",
    oemScreens: "Schermi OEM",
    partsBatteries: "Batterie",
    cameraModules: "Moduli Fotocamera",
    chargingPorts: "Porte di Ricarica",
    weeklySpecialDeals: "Offerte Speciali Settimanali",
    clearanceSale: "Vendita Promozionale",
    bundleDiscounts: "Sconti Pacchetto",
    tradeInOffers: "Valutazione Usato",
    gamingLaptops: "Laptop da Gioco",
    appleMacbooks: "Apple MacBook",
    allInOneDesktops: "Computer All-in-One",
    computerComponents: "Componenti PC",
    certifiedRefurbished: "Ricondizionato Certificato",
    preOwnedIphones: "iPhone Usati",
    usedSamsungGalaxy: "Samsung Galaxy Usati",
    budgetUsedPhones: "Telefoni Usati Economici",
    smartTVs: "Smart TV",
    actionCameras: "Action Cam",
    soundbarsSpeakers: "Soundbar e Altoparlanti",
    playstationXbox: "PlayStation & Xbox"
  },
  pt: {
    phoneCases: "Capas para Telemóvel",
    screenProtectors: "Películas de Écran",
    chargingCables: "Cabos de Carga",
    powerBanks: "Power Banks",
    smartWatches: "Relógios Inteligentes",
    fitnessBands: "Pulseiras de Atividade",
    wirelessEarbuds: "Auriculares Sem Fios",
    smartSpeakers: "Colunas Inteligentes",
    screenRepair: "Reparação de Écran",
    batteryReplacement: "Substituição de Bateria",
    softwareIssues: "Problemas de Software",
    warrantySupport: "Suporte de Garantia",
    oemScreens: "Écrans OEM",
    partsBatteries: "Baterias",
    cameraModules: "Módulos de Câmara",
    chargingPorts: "Portas de Carga",
    weeklySpecialDeals: "Ofertas Especiais Semanais",
    clearanceSale: "Venda de Liquidação",
    bundleDiscounts: "Descontos de Pacote",
    tradeInOffers: "Ofertas de Retoma",
    gamingLaptops: "Laptops para Jogos",
    appleMacbooks: "Apple MacBooks",
    allInOneDesktops: "Computadores All-in-One",
    computerComponents: "Componentes de Computador",
    certifiedRefurbished: "Certificado Recondicionado",
    preOwnedIphones: "iPhones Usados",
    usedSamsungGalaxy: "Samsung Galaxy Usado",
    budgetUsedPhones: "Telemóveis Usados Económicos",
    smartTVs: "Smart TVs",
    actionCameras: "Câmaras de Ação",
    soundbarsSpeakers: "Barras de Som & Colunas",
    playstationXbox: "PlayStation & Xbox"
  },
  el: {
    phoneCases: "Θήκες Τηλεφώνων",
    screenProtectors: "Προστατευτικά Οθόνης",
    chargingCables: "Καλώδια Φόρτισης",
    powerBanks: "Power Banks",
    smartWatches: "Έξυπνα Ρολόγια",
    fitnessBands: "Fitness Bands",
    wirelessEarbuds: "Ασύρματα Ακουστικά",
    smartSpeakers: "Έξυπνα Ηχεία",
    screenRepair: "Επισκευή Οθόνης",
    batteryReplacement: "Αντικατάσταση Μπαταρίας",
    softwareIssues: "Προβλήματα Λογισμικού",
    warrantySupport: "Υποστήριξη Εγγύησης",
    oemScreens: "Οθόνες OEM",
    partsBatteries: "Μπαταρίες",
    cameraModules: "Στοιχεία Κάμερας",
    chargingPorts: "Θύρες Φόρτισης",
    weeklySpecialDeals: "Εβδομαδιαίες Προσφορές",
    clearanceSale: "Εκκαθάριση",
    bundleDiscounts: "Εκπτώσεις Πακέτων",
    tradeInOffers: "Προσφορές Ανταλλαγής",
    gamingLaptops: "Gaming Laptops",
    appleMacbooks: "Apple MacBooks",
    allInOneDesktops: "Υπολογιστές All-in-One",
    computerComponents: "Εξαρτήματα Υπολογιστών",
    certifiedRefurbished: "Πιστοποιημένα Ανακατασκευασμένα",
    preOwnedIphones: "Μεταχειρισμένα iPhones",
    usedSamsungGalaxy: "Μεταχειρισμένα Samsung Galaxy",
    budgetUsedPhones: "Οικονομικά Μεταχειρισμένα Τηλέφωνα",
    smartTVs: "Έξυπνες Τηλεοράσεις",
    actionCameras: "Action Cameras",
    soundbarsSpeakers: "Ηχόμπαρες & Ηχεία",
    playstationXbox: "PlayStation & Xbox"
  }
};

const Header = () => {
  const dispatch = useDispatch();
  const cartCount = useSelector(selectCartCount);
  const { wishlistItems } = useWishlist();
  const wishlistCount = wishlistItems.length;
  const selectedLang = useSelector(selectLanguage) || { name: 'English', code: 'en', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg' };
  const [isLangOpen, setIsLangOpen] = useState(false);
  const langDropdownRef = useRef(null);

  const t = translations[selectedLang.code || 'en'] || translations.en;
  const mt = menuTranslations[selectedLang.code || 'en'] || menuTranslations.en;
  const searchQuery = useSelector(selectSearchQuery) || '';
  const [localSearchInput, setLocalSearchInput] = useState(searchQuery);
  const [allProducts, setAllProducts] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [mobileCategoriesOpen, setMobileCategoriesOpen] = useState(false);
  const [mobileBrandsOpen, setMobileBrandsOpen] = useState(false);
  const [isCategoriesMenuOpen, setIsCategoriesMenuOpen] = useState(false);
  const [isBrandsMenuOpen, setIsBrandsMenuOpen] = useState(false);
  const searchBoxRef = useRef(null);

  useEffect(() => {
    setLocalSearchInput(searchQuery);
  }, [searchQuery]);

  useEffect(() => {
    Promise.all([
      fetch('/api/products').then(res => res.json()),
      fetch('/api/services').then(res => res.json()).catch(() => []),
      fetch('/api/brand-products').then(res => res.json()).catch(() => [])
    ])
      .then(([productsData, servicesData, brandProductsData]) => {
        const combined = [
          ...productsData,
          ...(servicesData || []).map(s => ({ ...s, isService: true })),
          ...(brandProductsData || [])
        ];
        setAllProducts(combined);
      })
      .catch(err => console.error("Failed to load products for suggestions:", err));
  }, []);

  useEffect(() => {
    fetch('/api/brands')
      .then(res => res.json())
      .then(data => setBrands(Array.isArray(data) ? data : []))
      .catch(err => console.error("Failed to load brands:", err));
  }, []);

  useEffect(() => {
    fetch('/api/categories')
      .then(res => res.json())
      .then(data => setCategories(Array.isArray(data) ? data : []))
      .catch(err => console.error("Failed to load categories:", err));
  }, []);

  const getCategorySubcategories = (catName) => {
    const matched = categories.find(c => {
      const dbName = (c.name || '').toLowerCase().trim();
      const searchName = catName.toLowerCase().trim();
      return dbName === searchName || 
             (searchName === 'services' && dbName === 'service') ||
             (searchName === 'service' && dbName === 'services');
    });
    return matched ? (matched.subcategories || []) : [];
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchBoxRef.current && !searchBoxRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault();

    // Dispatch the local search term to trigger product filtering
    dispatch(setSearchQuery(localSearchInput));
    // Reset any active brand/category filters so the search query takes priority
    dispatch(setSelectedBrand('All'));
    dispatch(setSelectedCategory('All'));
    setShowSuggestions(false);

    // If not on home page, redirect to home page so products can filter
    if (window.location.pathname !== '/' && window.location.pathname !== '') {
      window.history.pushState({}, '', '/');
      window.dispatchEvent(new PopStateEvent('popstate'));
    }

    // Scroll to explore-products section
    setTimeout(() => {
      const element = document.getElementById('explore-products');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const handleSelectSuggestion = (product) => {
    setLocalSearchInput(product.name);
    setShowSuggestions(false);

    // Redirect to product details page directly
    const pId = product._id || product.id;
    window.history.pushState({}, '', `/product/${pId}`);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const filteredSuggestions = allProducts.filter(p => {
    if (!localSearchInput) return true;
    return (
      p.name?.toLowerCase().includes(localSearchInput.toLowerCase()) ||
      p.category?.toLowerCase().includes(localSearchInput.toLowerCase()) ||
      (p.keywords && Array.isArray(p.keywords)
        ? p.keywords.some(k => k.toLowerCase().includes(localSearchInput.toLowerCase()))
        : p.keywords?.toLowerCase().includes(localSearchInput.toLowerCase()))
    );
  }).slice(0, 8);

  const [user, setUser] = useState(null);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const userDropdownRef = useRef(null);

  useEffect(() => {
    const loadSession = () => {
      const session = localStorage.getItem('user_session');
      if (session) {
        setUser(JSON.parse(session));
      } else {
        setUser(null);
      }
    };

    loadSession();

    window.addEventListener('storage', loadSession);
    window.addEventListener('auth_change', loadSession);

    const handleClickOutside = (event) => {
      if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
        setIsUserDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('storage', loadSession);
      window.removeEventListener('auth_change', loadSession);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const languages = [
    { name: 'English', code: 'en', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/US.svg' },
    { name: 'Dutch', code: 'nl', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NL.svg' },
    { name: 'Greek', code: 'el', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GR.svg' },
    { name: 'Portuguese', code: 'pt', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/PT.svg' },
    { name: 'Spanish', code: 'es', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ES.svg' },
    { name: 'French', code: 'fr', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/FR.svg' },
    { name: 'German', code: 'de', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/DE.svg' },
    { name: 'Italian', code: 'it', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/IT.svg' },
  ];

  const handleLangSelect = (lang) => {
    dispatch(setLanguage(lang));
    setIsLangOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isMobileLangClick = event.target.closest('.mobile-drawer-lang-selector');
      const isDesktopLangClick = langDropdownRef.current && langDropdownRef.current.contains(event.target);

      if (!isMobileLangClick && !isDesktopLangClick) {
        setIsLangOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSectionNavigation = (e, sectionId) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);

    // 1. Force navigation back to home page
    window.history.pushState({}, '', '/');
    window.dispatchEvent(new PopStateEvent('popstate'));

    // 2. Scroll attempt function
    const tryScroll = () => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
      }
      return false;
    };

    // Try immediately
    if (!tryScroll()) {
      // Poll every 50ms for up to 1 second to catch React mounting delay
      let attempts = 0;
      const timer = setInterval(() => {
        attempts++;
        if (tryScroll() || attempts >= 20) {
          clearInterval(timer);
        }
      }, 50);
    }
  };

  const handleCategoryNav = (catName, e, initialFault = '', brandName = 'All', subCategoryName = 'All') => {
    if (e) e.preventDefault();
    setIsMobileMenuOpen(false);

    // Map to plural "Services" if singular "Service" is passed
    const normalizedCat = (catName.toLowerCase() === 'service' || catName.toLowerCase() === 'services') ? 'Services' : catName;

    if (normalizedCat === 'Services') {
      if (initialFault) {
        localStorage.setItem('service_initial_fault', initialFault);
        window.dispatchEvent(new CustomEvent('service_initial_fault_change', { detail: initialFault }));
      } else {
        localStorage.removeItem('service_initial_fault');
        window.dispatchEvent(new CustomEvent('service_initial_fault_change', { detail: '' }));
      }
    }

    if (subCategoryName && subCategoryName !== 'All') {
      localStorage.setItem('selected_subcategory', subCategoryName);
      window.dispatchEvent(new CustomEvent('selected_subcategory_change', { detail: subCategoryName }));
    } else {
      localStorage.removeItem('selected_subcategory');
      window.dispatchEvent(new CustomEvent('selected_subcategory_change', { detail: 'All' }));
    }

    dispatch(setSelectedCategory(normalizedCat));
    dispatch(setSelectedBrand(brandName));

    // 1. Force navigation back to home page if not already there
    if (window.location.pathname !== '/' && window.location.pathname !== '') {
      window.history.pushState({}, '', '/');
      window.dispatchEvent(new PopStateEvent('popstate'));
    }

    // 2. Scroll to explore products
    const tryScroll = () => {
      const element = document.getElementById('explore-products');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
      }
      return false;
    };

    if (!tryScroll()) {
      let attempts = 0;
      const timer = setInterval(() => {
        attempts++;
        if (tryScroll() || attempts >= 20) {
          clearInterval(timer);
        }
      }, 50);
    }
  };

  const handleBrandNav = (brandName, e) => {
    if (e) e.preventDefault();
    setIsMobileMenuOpen(false);
    dispatch(setSelectedCategory('All'));
    dispatch(setSelectedBrand(brandName));
    dispatch(setSearchQuery(''));

    // Force navigation back to home page if not already there
    if (window.location.pathname !== '/' && window.location.pathname !== '') {
      window.history.pushState({}, '', '/');
      window.dispatchEvent(new PopStateEvent('popstate'));
    }

    // Scroll to explore products
    const tryScroll = () => {
      const element = document.getElementById('explore-products');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
      }
      return false;
    };

    if (!tryScroll()) {
      let attempts = 0;
      const timer = setInterval(() => {
        attempts++;
        if (tryScroll() || attempts >= 20) {
          clearInterval(timer);
        }
      }, 50);
    }
  };

  const getCategoryProducts = (catName) => {
    const lowerCat = catName.toLowerCase().trim();
    const catProds = allProducts.filter(p => {
      if (lowerCat === 'services' || lowerCat === 'service') {
        return p.isService;
      }
      return p.category && p.category.toLowerCase().trim() === lowerCat;
    });
    return catProds.slice(0, 3);
  };

  const truncateName = (name, max = 22) => {
    if (!name) return "";
    return name.length > max ? name.substring(0, max) + "..." : name;
  };

  return (
    <header className="header-container">
      {/* 1. Top Delivery Banner */}
      <div className="top-delivery-banner">
        <span>{t.expressDelivery}</span>
        <span className="banner-separator">|</span>
        <span>{t.callOrWhatsapp}: +31-687748358</span>
      </div>

      {/* 2. Middle Brand Bar */}
      <div className="middle-brand-bar">
        <div className="brand-bar-inner">
          {/* Hamburger Menu Toggle Button (visible on mobile only) */}
          <button
            className="mobile-hamburger-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle Navigation Menu"
            style={{ display: 'none' }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>

          {/* Logo */}
          <div className="brand-logo" onClick={() => {
            window.history.pushState({}, '', '/');
            window.dispatchEvent(new PopStateEvent('popstate'));
          }}>
            <img src="/images/logo.png" alt="Smart Telecom Store" className="logo-img-file" />
          </div>

          <form onSubmit={handleSearchSubmit} className="brand-search-box" ref={searchBoxRef}>
            <input
              type="text"
              placeholder={t.searchPlaceholder}
              className="brand-search-input"
              value={localSearchInput}
              onChange={(e) => setLocalSearchInput(e.target.value)}
              onFocus={() => setShowSuggestions(true)}
            />
            <button type="submit" className="brand-search-button" aria-label="Search">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </button>

            {showSuggestions && filteredSuggestions.length > 0 && (
              <div className="search-suggestions-dropdown">
                {filteredSuggestions.map((p) => (
                  <div
                    key={p._id || p.id}
                    className="suggestion-item"
                    onClick={() => handleSelectSuggestion(p)}
                  >
                    <img src={p.image || ((p.images && p.images.length > 0) ? p.images[0] : '')} alt={p.name} className="suggestion-thumb" />
                    <div className="suggestion-info">
                      <span className="suggestion-name">{p.name}</span>
                      <span className="suggestion-category">{p.category || p.brand}</span>
                    </div>
                    <span className="suggestion-price">€{p.price.toFixed(2)}</span>
                  </div>
                ))}
                <div 
                  className="search-show-all-btn" 
                  onClick={(e) => {
                    e.preventDefault();
                    handleSearchSubmit();
                  }}
                >
                  Show all results for "{localSearchInput}"
                </div>
              </div>
            )}
          </form>

          {/* Phone Call Widget */}
          <div className="help-call-box">
            <div className="phone-icon-wrapper">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </div>
            <div className="call-text">
              <span className="call-label">{t.needHelp}</span>
              <span className="call-number">+31-687748358</span>
            </div>
          </div>

          {/* Header Actions */}
          <div className="brand-actions">
            {user ? (
              <div
                ref={userDropdownRef}
                className="header-action-item relative-dropdown user-dropdown-action"
                onClick={() => setIsUserDropdownOpen(!isUserDropdownOpen)}
                style={{ cursor: 'pointer' }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <span className="action-label" style={{ fontWeight: '600', color: 'var(--brand-red)' }}>{user.fullName}</span>
                <svg className="dropdown-arrow-small2" width="8" height="6" viewBox="0 0 8 6" fill="none">
                  <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                </svg>

                {isUserDropdownOpen && (
                  <ul className="user-dropdown-menu">
                    <li className="user-dropdown-header">
                      <strong>{user.fullName}</strong>
                      <span className="user-email-subtitle">{user.email}</span>
                    </li>
                    <li
                      className="user-dropdown-item logout-item"
                      onClick={(e) => {
                        e.stopPropagation();
                        localStorage.removeItem('user_session');
                        setUser(null);
                        setIsUserDropdownOpen(false);
                        window.dispatchEvent(new Event('auth_change'));

                        import('sweetalert2').then((Swal) => {
                          Swal.default.fire({
                            title: 'Signed Out',
                            text: 'You have been logged out successfully.',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                          });
                        });

                        window.history.pushState({}, '', '/');
                        window.dispatchEvent(new PopStateEvent('popstate'));
                      }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px', stroke: 'currentColor' }}>
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
                      </svg>
                      {t.signOut}
                    </li>
                  </ul>
                )}
              </div>
            ) : (
              <a
                href="/login"
                className="header-action-item"
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, '', '/login');
                  window.dispatchEvent(new PopStateEvent('popstate'));
                }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <span className="action-label">{t.signIn}</span>
              </a>
            )}

            <div
              ref={langDropdownRef}
              className="header-action-item relative-dropdown lang-selector-action"
              onClick={() => setIsLangOpen(!isLangOpen)}
            >
              <img src={selectedLang.flagUrl} alt={selectedLang.name} className="flag-img" />
              <span className="action-label">{selectedLang.name}</span>
              <svg className="dropdown-arrow-small2" width="8" height="6" viewBox="0 0 8 6" fill="none">
                <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
              </svg>

              {isLangOpen && (
                <ul className="lang-dropdown-menu">
                  {languages.map((lang) => (
                    <li
                      key={lang.name}
                      className={`lang-dropdown-item ${selectedLang.name === lang.name ? 'active-lang' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleLangSelect(lang);
                      }}
                    >
                      <img src={lang.flagUrl} alt={lang.name} className="flag-img" />
                      <span className="lang-name-text">{lang.name}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Wishlist Icon */}
            <div
              className="header-action-item wishlist-header-action"
              onClick={() => {
                const session = localStorage.getItem('user_session');
                window.history.pushState({}, '', session ? '/wish-list' : '/login');
                window.dispatchEvent(new PopStateEvent('popstate'));
              }}
              style={{ cursor: 'pointer' }}
            >
              <div className="wishlist-icon-wrapper">
                <svg width="22" height="22" viewBox="0 0 24 24" fill={wishlistCount > 0 ? '#be1e2d' : 'none'} stroke={wishlistCount > 0 ? '#be1e2d' : 'currentColor'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ transition: 'fill 0.2s, stroke 0.2s' }}>
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
                {wishlistCount > 0 && (
                  <span className="wishlist-header-badge">{wishlistCount}</span>
                )}
              </div>
            </div>

            <div
              className="header-action-item cart-action"
              onClick={() => {
                window.history.pushState({}, '', '/cart');
                window.dispatchEvent(new PopStateEvent('popstate'));
              }}
              style={{ cursor: 'pointer' }}
            >
              <div className="cart-icon-wrapper">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="9" cy="21" r="1" />
                  <circle cx="20" cy="21" r="1" />
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                </svg>
                <span className="cart-badge">{cartCount}</span>
              </div>
              <span className="action-label">{t.cart}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Drawer Backdrop */}
      {isMobileMenuOpen && (
        <div className="mobile-drawer-backdrop" onClick={() => setIsMobileMenuOpen(false)}></div>
      )}

      {/* 3. Bottom Navigation Bar */}
      <div className={`bottom-navigation-bar ${isMobileMenuOpen ? 'mobile-drawer-open' : ''}`}>
        <div className="navigation-bar-inner">
          {/* Mobile Drawer Header */}
          <div className="mobile-drawer-header">
            <span className="drawer-title">Menu</span>
            <button
              className="mobile-drawer-close-btn"
              onClick={() => setIsMobileMenuOpen(false)}
              aria-label="Close Menu"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          {/* Navigation Links */}
          <nav className="nav-menu">
            <a
              href="/about-us"
              className="menu-item link"
              onClick={(e) => {
                e.preventDefault();
                setIsMobileMenuOpen(false);
                window.history.pushState({}, '', '/about-us');
                window.dispatchEvent(new PopStateEvent('popstate'));
              }}
            >
              {t.aboutUs}
            </a>
            <div
              className={`menu-item dropdown categories-dropdown-wrapper ${mobileCategoriesOpen ? 'mobile-submenu-open' : ''}`}
              onMouseEnter={() => setIsCategoriesMenuOpen(true)}
              onMouseLeave={() => setIsCategoriesMenuOpen(false)}
              onClick={(e) => {
                if (window.innerWidth < 768) {
                  if (e.target.closest('.menu-item') === e.currentTarget || e.target.tagName === 'SPAN' || e.target.tagName === 'svg' || e.target.tagName === 'path') {
                    setMobileCategoriesOpen(!mobileCategoriesOpen);
                  }
                }
              }}
            >
              <span>{t.categories}</span>
              <svg className={`dropdown-arrow-small ${mobileCategoriesOpen ? 'rotated' : ''}`} width="8" height="6" viewBox="0 0 8 6" fill="none">
                <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
              </svg>

              {/* Mega Menu */}
              <div 
                className="mega-menu-container"
                style={window.innerWidth >= 768 ? { display: isCategoriesMenuOpen ? 'block' : 'none' } : {}}
                onClick={() => setIsCategoriesMenuOpen(false)}
              >
                <div className="mega-menu-inner">
                  {/* Column 1 */}
                  <div className="mega-menu-column">
                    <div className="mega-menu-section">
                      <a href="#mobile-phone" className="mega-menu-heading" onClick={(e) => handleCategoryNav("Mobile Phone", e)}>
                        <span>{t.categoryMobilePhone || "Mobile Phone"}</span>
                        <svg className="category-dropdown-arrow" width="8" height="6" viewBox="0 0 8 6" fill="none">
                          <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>
                      </a>
                      <ul className="mega-menu-list">
                        {getCategorySubcategories("Mobile Phone").map(sub => (
                          <li key={sub}>
                            <a 
                              href={`#${sub.toLowerCase().replace(/\s+/g, '-')}`}
                              onClick={(e) => handleCategoryNav("Mobile Phone", e, '', 'All', sub)}
                            >
                              {sub}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="mega-menu-section">
                      <a href="#accessories" className="mega-menu-heading" onClick={(e) => handleCategoryNav("Accessories", e)}>
                        <span>{t.categoryAccessories || "Accessories"}</span>
                        <svg className="category-dropdown-arrow" width="8" height="6" viewBox="0 0 8 6" fill="none">
                          <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>
                      </a>
                      <ul className="mega-menu-list">
                        {getCategorySubcategories("Accessories").map(sub => (
                          <li key={sub}>
                            <a 
                              href={`#${sub.toLowerCase().replace(/\s+/g, '-')}`}
                              onClick={(e) => handleCategoryNav("Accessories", e, '', 'All', sub)}
                            >
                              {sub}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="mega-menu-section">
                      <a href="#gadget" className="mega-menu-heading" onClick={(e) => handleCategoryNav("Gadget", e)}>
                        <span>{t.categoryFormat || t.categoryGadget || "Gadget"}</span>
                        <svg className="category-dropdown-arrow" width="8" height="6" viewBox="0 0 8 6" fill="none">
                          <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>
                      </a>
                      <ul className="mega-menu-list">
                        {getCategorySubcategories("Gadget").map(sub => (
                          <li key={sub}>
                            <a 
                              href={`#${sub.toLowerCase().replace(/\s+/g, '-')}`}
                              onClick={(e) => handleCategoryNav("Gadget", e, '', 'All', sub)}
                            >
                              {sub}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* Column 2 */}
                  <div className="mega-menu-column">
                    <div className="mega-menu-section">
                      <a href="#service" className="mega-menu-heading" onClick={(e) => handleCategoryNav("Services", e)}>
                        <span>{t.categoryService || "Service"}</span>
                        <svg className="category-dropdown-arrow" width="8" height="6" viewBox="0 0 8 6" fill="none">
                          <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>
                      </a>
                      <ul className="mega-menu-list">
                        {getCategorySubcategories("Services").map(sub => (
                          <li key={sub}>
                            <a 
                              href={`#${sub.toLowerCase().replace(/\s+/g, '-')}`}
                              onClick={(e) => handleCategoryNav("Services", e, '', 'All', sub)}
                            >
                              {sub}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="mega-menu-section">
                      <a href="#parts" className="mega-menu-heading" onClick={(e) => handleCategoryNav("Parts", e)}>
                        <span>{t.categoryParts || "Parts"}</span>
                        <svg className="category-dropdown-arrow" width="8" height="6" viewBox="0 0 8 6" fill="none">
                          <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>
                      </a>
                      <ul className="mega-menu-list">
                        {getCategorySubcategories("Parts").map(sub => (
                          <li key={sub}>
                            <a 
                              href={`#${sub.toLowerCase().replace(/\s+/g, '-')}`}
                              onClick={(e) => handleCategoryNav("Parts", e, '', 'All', sub)}
                            >
                              {sub}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="mega-menu-section">
                      <a href="#offers" className="mega-menu-heading" onClick={(e) => handleCategoryNav("Offers", e)}>
                        <span>{t.categoryOffers || "Offers"}</span>
                        <svg className="category-dropdown-arrow" width="8" height="6" viewBox="0 0 8 6" fill="none">
                          <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>
                      </a>
                      <ul className="mega-menu-list">
                        {getCategorySubcategories("Offers").map(sub => (
                          <li key={sub}>
                            <a 
                              href={`#${sub.toLowerCase().replace(/\s+/g, '-')}`}
                              onClick={(e) => handleCategoryNav("Offers", e, '', 'All', sub)}
                            >
                              {sub}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* Column 3 */}
                  <div className="mega-menu-column">
                    <div className="mega-menu-section">
                      <a href="#computers" className="mega-menu-heading" onClick={(e) => handleCategoryNav("Computers", e)}>
                        <span>{t.categoryComputers || "Computers"}</span>
                        <svg className="category-dropdown-arrow" width="8" height="6" viewBox="0 0 8 6" fill="none">
                          <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>
                      </a>
                      <ul className="mega-menu-list">
                        {getCategorySubcategories("Computers").map(sub => (
                          <li key={sub}>
                            <a 
                              href={`#${sub.toLowerCase().replace(/\s+/g, '-')}`}
                              onClick={(e) => handleCategoryNav("Computers", e, '', 'All', sub)}
                            >
                              {sub}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="mega-menu-section">
                      <a href="#used-phone" className="mega-menu-heading" onClick={(e) => handleCategoryNav("Used Phone", e)}>
                        <span>{t.categoryUsedPhone || "Used Phone"}</span>
                        <svg className="category-dropdown-arrow" width="8" height="6" viewBox="0 0 8 6" fill="none">
                          <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>
                      </a>
                      <ul className="mega-menu-list">
                        {getCategorySubcategories("Used Phone").map(sub => (
                          <li key={sub}>
                            <a 
                              href={`#${sub.toLowerCase().replace(/\s+/g, '-')}`}
                              onClick={(e) => handleCategoryNav("Used Phone", e, '', 'All', sub)}
                            >
                              {sub}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="mega-menu-section">
                      <a href="#electronics" className="mega-menu-heading" onClick={(e) => handleCategoryNav("Electronics", e)}>
                        <span>{t.categoryElectronics || "Electronics"}</span>
                        <svg className="category-dropdown-arrow" width="8" height="6" viewBox="0 0 8 6" fill="none">
                          <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                        </svg>
                      </a>
                      <ul className="mega-menu-list">
                        {getCategorySubcategories("Electronics").map(sub => (
                          <li key={sub}>
                            <a 
                              href={`#${sub.toLowerCase().replace(/\s+/g, '-')}`}
                              onClick={(e) => handleCategoryNav("Electronics", e, '', 'All', sub)}
                            >
                              {sub}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* Column 4 (Right side, Categories Image Grid) */}
                  <div className="mega-menu-column grid-column">
                    <div className="mega-menu-grid-six">
                      <a href="#mobile-phone" className="mega-grid-item" onClick={(e) => handleCategoryNav("Mobile Phone", e)}>
                        <img src="/images/hero_gadget.webp" alt="Mobile Phone" className="mega-grid-img" />
                      </a>
                      <a href="#accessories" className="mega-grid-item" onClick={(e) => handleCategoryNav("Accessories", e)}>
                        <img src="/images/promo_headphones.png" alt="Accessories" className="mega-grid-img" />
                      </a>
                      <a href="#gadget" className="mega-grid-item" onClick={(e) => handleCategoryNav("Gadget", e)}>
                        <img src="/images/promo_smartwatch.png" alt="Gadget" className="mega-grid-img" />
                      </a>
                      <a href="#service" className="mega-grid-item" onClick={(e) => handleCategoryNav("Services", e)}>
                        <img src="/images/phone_repair_service.png" alt="Service" className="mega-grid-img" />
                      </a>
                      <a href="#parts" className="mega-grid-item" onClick={(e) => handleCategoryNav("Parts", e)}>
                        <img src="/images/phone_parts.png" alt="Parts" className="mega-grid-img" />
                      </a>
                      <a href="#computers" className="mega-grid-item" onClick={(e) => handleCategoryNav("Computers", e)}>
                        <img src="/images/premium_laptop.png" alt="Computers" className="mega-grid-img" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`menu-item dropdown brands-dropdown-wrapper ${mobileBrandsOpen ? 'mobile-submenu-open' : ''}`}
              onMouseEnter={() => setIsBrandsMenuOpen(true)}
              onMouseLeave={() => setIsBrandsMenuOpen(false)}
              onClick={(e) => {
                if (window.innerWidth < 768) {
                  if (e.target.closest('.menu-item') === e.currentTarget || e.target.tagName === 'SPAN' || e.target.tagName === 'svg' || e.target.tagName === 'path') {
                    setMobileBrandsOpen(!mobileBrandsOpen);
                  }
                }
              }}
            >
              <span>{t.brands || "Brands"}</span>
              <svg className={`dropdown-arrow-small ${mobileBrandsOpen ? 'rotated' : ''}`} width="8" height="6" viewBox="0 0 8 6" fill="none">
                <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
              </svg>

              <div 
                className="brands-dropdown-menu"
                style={window.innerWidth >= 768 ? { display: isBrandsMenuOpen ? 'block' : 'none' } : {}}
                onClick={() => setIsBrandsMenuOpen(false)}
              >
                {brands.length === 0 ? (
                  <div style={{ padding: '15px 20px', color: '#718096', fontSize: '13px', textAlign: 'center' }}>
                    No brands available
                  </div>
                ) : (
                  <div className="brands-dropdown-columns">
                    {Array.from({ length: Math.ceil(brands.length / 8) }, (_, i) => brands.slice(i * 8, i * 8 + 8)).map((columnBrands, colIdx) => (
                      <div key={colIdx} className="brands-dropdown-column">
                        {columnBrands.map((b) => (
                          <a
                            key={b._id || b.name}
                            href={`#brand-${b.name.toLowerCase()}`}
                            className="brand-dropdown-item"
                            onClick={(e) => handleBrandNav(b.name, e)}
                          >
                            {b.image ? (
                              <img src={b.image} alt={b.name} />
                            ) : (
                              <div className="brand-dropdown-item-initials">
                                {b.name.substring(0, 2).toUpperCase()}
                              </div>
                            )}
                            <span>{b.name}</span>
                          </a>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {user && user.email === 'smarttelecom.nl@gmail.com' && (
              <a
                href="/admin"
                className="menu-item link"
                style={{ color: 'var(--brand-red)', fontWeight: '600' }}
                onClick={(e) => {
                  e.preventDefault();
                  setIsMobileMenuOpen(false);
                  window.history.pushState({}, '', '/admin');
                  window.dispatchEvent(new PopStateEvent('popstate'));
                }}
              >
                Admin Panel
              </a>
            )}

            <a
              href="/contact-us"
              className="menu-item link"
              onClick={(e) => {
                e.preventDefault();
                setIsMobileMenuOpen(false);
                window.history.pushState({}, '', '/contact-us');
                window.dispatchEvent(new PopStateEvent('popstate'));
              }}
            >
              {t.contactUs}
            </a>

            <a
              href="#explore-products"
              className="menu-item link"
              onClick={(e) => {
                setIsMobileMenuOpen(false);
                handleSectionNavigation(e, 'explore-products');
              }}
            >
              {t.products}
            </a>
            <a
              href="#new-arrivals"
              className="menu-item link"
              onClick={(e) => {
                setIsMobileMenuOpen(false);
                handleSectionNavigation(e, 'new-arrivals');
              }}
            >
              {t.newArrival}
            </a>
          </nav>

          {/* Mobile Drawer Actions (User status, language, help widget) */}
          <div className="mobile-drawer-actions">
            {user ? (
              <div className="mobile-drawer-action-item profile">
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  <span className="mobile-username">{user.fullName}</span>
                </div>
                <button
                  className="mobile-logout-btn"
                  onClick={() => {
                    localStorage.removeItem('user_session');
                    setUser(null);
                    setIsMobileMenuOpen(false);
                    window.dispatchEvent(new Event('auth_change'));
                    import('sweetalert2').then((Swal) => {
                      Swal.default.fire({
                        title: 'Signed Out',
                        text: 'You have been logged out successfully.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                      });
                    });
                    window.history.pushState({}, '', '/');
                    window.dispatchEvent(new PopStateEvent('popstate'));
                  }}
                >
                  {t.signOut}
                </button>
              </div>
            ) : (
              <a
                href="/login"
                className="mobile-drawer-action-item"
                onClick={(e) => {
                  e.preventDefault();
                  setIsMobileMenuOpen(false);
                  window.history.pushState({}, '', '/login');
                  window.dispatchEvent(new PopStateEvent('popstate'));
                }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <span>{t.signIn}</span>
              </a>
            )}

            {/* Mobile Language Selector */}
            <div className="mobile-drawer-lang-selector">
              <div className="mobile-lang-trigger" onClick={() => setIsLangOpen(!isLangOpen)}>
                <img src={selectedLang.flagUrl} alt={selectedLang.name} className="flag-img" />
                <span style={{ marginLeft: '10px', marginRight: '5px' }}>{selectedLang.name}</span>
                <svg className={`dropdown-arrow-small2 ${isLangOpen ? 'rotated' : ''}`} width="8" height="6" viewBox="0 0 8 6" fill="none" style={{ marginLeft: 'auto' }}>
                  <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                </svg>
              </div>
              {isLangOpen && (
                <ul className="mobile-lang-list">
                  {languages.map((lang) => (
                    <li
                      key={lang.name}
                      className={`mobile-lang-item ${selectedLang.name === lang.name ? 'active' : ''}`}
                      onClick={() => {
                        handleLangSelect(lang);
                        setIsMobileMenuOpen(false);
                      }}
                    >
                      <img src={lang.flagUrl} alt={lang.name} className="flag-img" />
                      <span>{lang.name}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            {/* Mobile Drawer Help Widget */}
            <div className="mobile-drawer-help">
              <div className="phone-icon-wrapper">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <div className="call-text">
                <span className="call-label">{t.needHelp}</span>
                <a href="tel:+31687748358" className="call-number" style={{ color: '#ffffff', fontSize: '13px', fontWeight: 'bold' }}>+31-687748358</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 4. Sub Navigation Links Bar */}
      {/* <div className="sub-navigation-bar">
        <div className="sub-navigation-inner">
          <a href="#brands" className="sub-nav-link">Brands</a>
          <a href="#flash-sale" className="sub-nav-link">Flash Sale</a>
          <a href="#apple" className="sub-nav-link">Apple</a>
          <a href="#samsung" className="sub-nav-link">Samsung</a>
          <a href="#google-pixel" className="sub-nav-link">Google Pixel</a>
          <a href="#ipads" className="sub-nav-link">IPads</a>
          <a href="#macbook" className="sub-nav-link">Macbook</a>
          <a href="#tablets" className="sub-nav-link">Tablets</a>
          <a href="#smart-watches" className="sub-nav-link">Smart Watches</a>
          <a href="#airbuds" className="sub-nav-link">Airbuds</a>
          <a href="#accessories" className="sub-nav-link">Accessories</a>
          <a href="#gaming" className="sub-nav-link">Gaming</a>
        </div>
      </div> */}
    </header>
  );
};

export default Header;

